/* Field — Lenis smooth scroll (https://github.com/darkroom-engineering/lenis).
 * Wraps the vendored assets/lenis.min.js in the same guards as field-motion.js:
 * reduced-motion users and the theme editor keep native scrolling, and touch
 * devices are untouched (Lenis leaves touch native by default). Scroll events
 * stay native, so the IntersectionObserver reveals and --fd-progress scenes in
 * field-motion.js keep working unchanged.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = document.documentElement.classList.contains('shopify-design-mode');

  if (reduced || designMode || typeof window.Lenis !== 'function') return;

  /* Drawers, modals and other overlay scroll areas keep native wheel scroll */
  var PREVENT_SELECTOR = [
    'cart-drawer',
    'cart-notification',
    'menu-drawer',
    'details-modal',
    'predictive-search',
    '.menu-drawer__navigation-container',
    '[data-lenis-prevent]'
  ].join(',');

  function boot() {
    /* No `anchors` option: in-page anchors (e.g. the skip-to-content link)
       keep their native jump + focus hand-off; Lenis syncs to native scroll. */
    window.fieldLenis = new window.Lenis({
      autoRaf: true,
      lerp: 0.09,
      prevent: function (node) {
        return !!(node && node.closest && node.closest(PREVENT_SELECTOR));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
